import { LinkProps } from '@tanstack/react-router';
import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useState,
} from 'react';

type BreadCrumb = LinkProps & { label: string };

interface BreadCrumbContext {
  crumbs: BreadCrumb[];
  setCrumbs: Dispatch<SetStateAction<BreadCrumb[]>>;
}

const BreadCrumbContext = createContext<BreadCrumbContext>(
  {} as BreadCrumbContext
);

export const BreadCrumbProvider = ({ children }: { children: ReactNode }) => {
  const [crumbs, setCrumbs] = useState<BreadCrumb[]>([]);

  return (
    <BreadCrumbContext.Provider
      value={{
        crumbs,
        setCrumbs,
      }}
    >
      {children}
    </BreadCrumbContext.Provider>
  );
};

export const useBreadCrumbs = () => {
  const context = useContext(BreadCrumbContext);

  return context;
};
